<template>
  <full-screen :title="t('about.title')" @close="router.back()" :show-close="true">
    <div class="flex flex-col items-center sm:justify-center min-h-full py-8 px-4">
      <div class="flex flex-col items-center">
        <img src="/logo.png" class="max-h-10 sm:max-h-20" />
        <div class="text-n-200 mt-3">{{ t('about.version') }}: {{ appVersion }}</div>
      </div>

      <div v-if="isGermany" class="flex flex-col gap-4 justify-center mt-8 text-sm max-w-md">
        <div class="text-n-100 font-medium">{{ t('about.eas-details') }}</div>
        <div class="grid grid-cols-2 gap-2">
          <div class="text-n-200">{{ t('about.eas-type') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">Kassensystem</div>
          <div class="text-n-200">{{ t('about.eas-software') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">Last.app</div>
          <div class="text-n-200">{{ t('about.eas-version') }}</div>
          <div class="text-n-0">{{ appVersion }}</div>
          <div class="text-n-200">{{ t('about.eas-serial') }}</div>
          <div class="text-n-0 break-all">{{ config.locationId }}</div>
          <div class="text-n-200">{{ t('about.eas-manufacturer') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">Last Technologies S.L.</div>
          <div class="text-n-200">{{ t('about.eas-model') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">Last.app</div>
          <div class="text-n-200">{{ t('about.eas-acquisition-date') }}</div>
          <div class="text-n-0">{{ formatDate(kassensichvInfo?.locationCreationTime) }}</div>
          <div class="text-n-200">{{ t('about.eas-first-use-date') }}</div>
          <div class="text-n-0">{{ formatDate(kassensichvInfo?.locationCreationTime) }}</div>
        </div>

        <div class="text-n-100 font-medium mt-4">{{ t('about.tse-details') }}</div>
        <div class="grid grid-cols-2 gap-2">
          <div class="text-n-200">{{ t('about.tse-serial') }}</div>
          <div class="text-n-0 break-all">{{ kassensichvInfo?.tseSerialNumber }}</div>
          <div class="text-n-200">{{ t('about.tse-certification') }}</div>
          <div class="text-n-0">{{ kassensichvInfo?.tseCertificationId }}</div>
          <div class="text-n-200">{{ t('about.tse-activation-date') }}</div>
          <div class="text-n-0">{{ formatDate(kassensichvInfo?.tseActivationDate) }}</div>
          <div class="text-n-200">{{ t('about.tse-type') }}</div>
          <div class="text-n-0">{{ kassensichvInfo?.tseType }}</div>
        </div>
      </div>

      <div v-else class="flex flex-col gap-5 justify-center mt-16">
        <div class="flex flex-col items-center">
          <div class="text-n-200 mr-2">{{ t('about.software-name') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">LastPOS</div>
        </div>
        <div class="flex flex-col items-center">
          <div class="text-n-200 mr-2">{{ t('about.developer') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">Last Systems S.L.</div>
        </div>
        <div class="flex flex-col items-center">
          <div class="text-n-200 mr-2">{{ t('about.tax-id') }}</div>
          <!-- eslint-disable-next-line -->
          <div class="text-n-0">B67417758</div>
        </div>
      </div>
    </div>
  </full-screen>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import FullScreen from '@/components/FullScreen.vue'
import { useConfigStore } from '@/store/config'

const configStore = useConfigStore()
const { appVersion, config } = storeToRefs(configStore)

const { t } = useI18n()
const router = useRouter()

const isGermany = computed(() => config.value.locationCountryCode === 'DE')
const kassensichvInfo = computed(() => config.value.kassensichvInfo)

function formatDate(date: string | null | undefined) {
  if (!date) return '-'
  return format(new Date(date), 'dd/MM/yyyy, HH:mm:ss')
}
</script>
